export const GENERAL_MESSAGE = 'GENERAL_MESSAGE';
export const API_MESSAGE     = 'API_MESSAGE';
export const API_ERROR       = 'API_ERROR';
export const TWO_ACTION      = 'TWO_ACTION';
export const Treatment = "Treatment";
export const Agent = "Agent";
export const Battery = "Battery";
export const Iframe ="Iframe";
